import { render } from "./ManagementClass.vue?vue&type=template&id=4ad86a94&scoped=true"
import script from "./ManagementClass.vue?vue&type=script&lang=js"
export * from "./ManagementClass.vue?vue&type=script&lang=js"

import "./ManagementClass.vue?vue&type=style&index=0&id=4ad86a94&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad86a94"]])

export default __exports__